var _path, _line, _line2, _line3, _line4, _line5, _line6, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBundleFileIcon = function SvgBundleFileIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6673 31.6667C36.6673 32.5507 36.3161 33.3986 35.691 34.0237C35.0659 34.6488 34.218 35 33.334 35H6.66732C5.78326 35 4.93542 34.6488 4.31029 34.0237C3.68517 33.3986 3.33398 32.5507 3.33398 31.6667V8.33333C3.33398 7.44928 3.68517 6.60143 4.31029 5.97631C4.93542 5.35119 5.78326 5 6.66732 5H15.0007L18.334 10H33.334C34.218 10 35.0659 10.3512 35.691 10.9763C36.3161 11.6014 36.6673 12.4493 36.6673 13.3333V31.6667Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 27.7,
    y1: 10.7,
    x2: 27.7,
    y2: 23.3,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.3,
    y1: 12.7,
    x2: 27.7,
    y2: 12.7,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 30.3,
    y1: 16.7,
    x2: 27.7,
    y2: 16.7,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 30.3,
    y1: 20.7,
    x2: 27.7,
    y2: 20.7,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 27.3,
    y1: 14.7,
    x2: 24.7,
    y2: 14.7,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 27.3,
    y1: 18.7,
    x2: 24.7,
    y2: 18.7,
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24H29.5V26.625C29.5 27.5915 28.7165 28.375 27.75 28.375V28.375C26.7835 28.375 26 27.5915 26 26.625V24Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBundleFileIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "34593572b642a00c90add10c1789bbb2.svg";